import React from "react";
import { Helmet } from "react-helmet-async";

export default function SEO({
  title,
  description,
  ogImage,
  canonical,
  lang = "da"
}) {
  const defaultTitle = "Elmegaarden Have og Anlæg";
  const finalTitle = title || defaultTitle;
  const siteUrl = "https://elmegaardenhaveoganlaeg.dk";
  const canonicalUrl = canonical
    ? (canonical.startsWith("http") ? canonical : `${siteUrl}${canonical}`)
    : undefined;

  return (
    <Helmet htmlAttributes={{ lang }}>
      {finalTitle && <title>{finalTitle}</title>}
      {description && <meta name="description" content={description} />}
      {finalTitle && <meta property="og:title" content={finalTitle} />}
      {description && <meta property="og:description" content={description} />}
      {ogImage && <meta property="og:image" content={ogImage} />}
      {ogImage && <meta name="twitter:image" content={ogImage} />}
      <meta name="twitter:card" content={ogImage ? "summary_large_image" : "summary"} />
      {finalTitle && <meta name="twitter:title" content={finalTitle} />}
      {description && <meta name="twitter:description" content={description} />}
      {canonicalUrl && <link rel="canonical" href={canonicalUrl} />}
    </Helmet>
  );
}
